import { gql } from "hooks/urql"

import lessonResourcesFragment from "./lessonResourcesFragment"

export default gql`
  ${lessonResourcesFragment}
  fragment LessonTopicsFields on LessonTopic {
    id
    name
    sortOrder
    signedUrl {
      url
      key
      successActionStatus
      acl
      policy
      credential
      algorithm
      date
      signature
    }
    lessonResources {
      ...LessonResourcesFields
    }
  }
`
